/**
 * Accounting > Invoice Approvals. Every vendor bill that is not a crabber or a hauler:
 * shrimp, coolers, supplies, utilities (Mercedes + Greg, 2026-09-17).
 *
 * The same board as Crabber & Freight Approvals, filtered to invoice bills, so the chain,
 * the uploads, ready-to-pay and the paid archive are one piece of code rather than two
 * that drift. What is different lives in its own files: the history beside a bill
 * (components/InvoiceContext.js) and the buyer coach (components/InvoiceCoach.js).
 */
import React from 'react';
import Approvals from './Approvals';

export default function InvoiceApprovals({ initialDocumentId = null }) {
  return <Approvals kind="invoice" initialDocumentId={initialDocumentId} />;
}
